import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const
  Redes = lazy(() => import('../../../views/Redes/index'))


const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`/redes-sociales`} component={Redes} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
